/* /farbanje-kose (/en/hair-colouring, /de/haare-faerben)

   Every price is rendered as text in a real <table>. A competitor publishes
   their price list as an image, which Google cannot read - that is the whole
   reason this page exists in this shape. */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Bredcrumb from '../../HomeMain/Bredcrumb';
import Appointment from '../../HomeMain/Appointment';
import Faq from '../../ui/Faq';
import {
  Section, Heading, P, PriceTable, PriceList, BRAND, INK, sans,
} from '../../ui/blocks';
import { HAIR } from '../../../config/prices.mjs';
import { linkTo } from '../../../i18n/lang.mjs';

const TREATMENTS = '/tretmani-kose';
const BALAYAGE = '/balayage';

const Main = () => {
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';

  const lengths = t('hairColouring.pricing.lengths', { returnObjects: true });
  const bleachLengths = t('hairColouring.pricing.bleachWholeLengths', { returnObjects: true });
  const faq = t('hairColouring.faq.items', { returnObjects: true });

  const byLength = (prices, labels = lengths) =>
    labels.map((label, i) => ({ label, price: prices[i] }));

  const linkStyle = {
    display: 'inline-block',
    marginTop: '6px',
    fontFamily: sans,
    fontSize: '15px',
    fontWeight: 600,
    color: BRAND,
  };

  return (
    <>
      <Bredcrumb title={t('pages.hairColouring.title')} subtitle={t('pages.hairColouring.subtitle')} />

      <Section>
        <P style={{ fontSize: '18px', color: INK, fontWeight: 500 }}>{t('hairColouring.intro.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairColouring.intro.p2')}</P>
      </Section>

      <PriceList
        title={t('hairColouring.pricing.heading')}
        footnote={t('hairColouring.pricing.note')}
      >
        <PriceTable caption={t('hairColouring.pricing.wholeHair')} rows={byLength(HAIR.farbanjeCela)} />

        <PriceTable
          caption={t('hairColouring.pricing.single')}
          rows={[
            { label: t('hairColouring.pricing.roots'), price: HAIR.farbanjeIzrastak },
            { label: t('hairColouring.pricing.ownColour'), price: HAIR.farbanjeUsluzno },
          ]}
        />

        <PriceTable caption={t('hairColouring.pricing.toner')} rows={byLength(HAIR.preliv)} />

        <PriceTable caption={t('hairColouring.pricing.bleachRoots')} rows={byLength(HAIR.blajhanjeIzrastka)} />

        <PriceTable
          caption={t('hairColouring.pricing.bleachWhole')}
          rows={byLength(HAIR.blajhanjeCele, bleachLengths)}
        />
      </PriceList>

      <Section>
        <Heading>{t('hairColouring.shade.heading')}</Heading>
        <P>{t('hairColouring.shade.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('hairColouring.shade.p2')}</P>
      </Section>

      <Section tinted>
        <Heading>{t('hairColouring.aftercare.heading')}</Heading>
        <P>{t('hairColouring.aftercare.p1')}</P>
        <P>{t('hairColouring.aftercare.p2')}</P>
        <Link to={linkTo(TREATMENTS, lang)} style={linkStyle}>
          {t('hairColouring.aftercare.treatmentsLink')} →
        </Link>
        <P style={{ marginTop: '20px' }}>{t('hairColouring.aftercare.p3')}</P>
        <Link to={linkTo(BALAYAGE, lang)} style={linkStyle}>
          {t('hairColouring.aftercare.balayageLink')} →
        </Link>
      </Section>

      <Section>
        <Heading align="center">{t('hairColouring.faq.heading')}</Heading>
        <Faq items={faq} />
      </Section>

      {/* Same booking form as /contact, pre-filled with this page's service. */}
      <Appointment defaultService="Farbanje kose" />

    </>
  );
};

export default Main;
